import { Info } from "@phosphor-icons/react";

// Low-key, always-visible advisory (not a hard block). Encourages users to keep
// company-specific material on their own secured systems. Shown across the
// public-info-oriented modules (STaR, 5 P's, ClaroLens, IRA, Readiness Gaps,
// Required Docs, CIP-013). `context` is an optional leading sentence.
export const DataResidencyNote = ({ context, className = "" }) => (
  <div
    data-testid="data-residency-note"
    className={`flex items-start gap-2 text-[12px] leading-relaxed text-muted-foreground border-l-2 border-sky-300 bg-sky-50/70 dark:bg-sky-950/20 px-3 py-2 ${className}`}
  >
    <Info size={14} weight="bold" className="mt-0.5 shrink-0 text-sky-600" />
    <span>
      {context ? <span className="font-medium text-foreground/80">{context} </span> : null}
      We recommend keeping company-specific evidence, policies, and asset details on your own
      secured systems, and adding only what you're comfortable storing in ClaroShield.
    </span>
  </div>
);
